export enum PagesEnum {
  HOME_PAGE = '/',
}
